// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ICalculateScheduleRequestDto } from './ICalculateScheduleRequestDto';
import {
    ICalculateScheduleRequestDtoFromJSON,
    ICalculateScheduleRequestDtoFromJSONTyped,
    ICalculateScheduleRequestDtoToJSON,
    ICalculateScheduleRequestDtoToJSONTyped,
} from './ICalculateScheduleRequestDto';

/**
 * 
 * @export
 * @interface IPayrollCalendarUpdateDto
 */
export interface IPayrollCalendarUpdateDto {
    /**
     * 
     * @type {string}
     * @memberof IPayrollCalendarUpdateDto
     */
    calendar_name: string;
    /**
     * 
     * @type {string}
     * @memberof IPayrollCalendarUpdateDto
     */
    frequency_type: IPayrollCalendarUpdateDtoFrequencyTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IPayrollCalendarUpdateDto
     */
    group_type: IPayrollCalendarUpdateDtoGroupTypeEnum;
    /**
     * 
     * @type {ICalculateScheduleRequestDto}
     * @memberof IPayrollCalendarUpdateDto
     */
    calculate_schedule_request_dto: ICalculateScheduleRequestDto;
    /**
     * 
     * @type {Set<Date>}
     * @memberof IPayrollCalendarUpdateDto
     */
    scheduled_dates: Set<Date>;
    /**
     * 
     * @type {Set<number>}
     * @memberof IPayrollCalendarUpdateDto
     */
    plan_ids?: Set<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof IPayrollCalendarUpdateDto
     */
    all_plan_ids?: Array<number>;
    /**
     * 
     * @type {Set<number>}
     * @memberof IPayrollCalendarUpdateDto
     */
    payroll_group_ids?: Set<number>;
}

/**
* @export
* @enum {string}
*/
export enum IPayrollCalendarUpdateDtoFrequencyTypeEnum {
    WEEKLY = 'WEEKLY',
    BI_WEEKLY = 'BI_WEEKLY',
    MONTHLY = 'MONTHLY',
    SEMI_MONTHLY = 'SEMI_MONTHLY',
    ANNUALLY = 'ANNUALLY'
}
/**
* @export
* @enum {string}
*/
export enum IPayrollCalendarUpdateDtoGroupTypeEnum {
    ALL = 'ALL',
    GROUP = 'GROUP',
    PLAN = 'PLAN'
}


/**
 * Check if a given object implements the IPayrollCalendarUpdateDto interface.
 */
export function instanceOfIPayrollCalendarUpdateDto(value: object): value is IPayrollCalendarUpdateDto {
    if (!('calendar_name' in value) || value['calendar_name'] === undefined) return false;
    if (!('frequency_type' in value) || value['frequency_type'] === undefined) return false;
    if (!('group_type' in value) || value['group_type'] === undefined) return false;
    if (!('calculate_schedule_request_dto' in value) || value['calculate_schedule_request_dto'] === undefined) return false;
    if (!('scheduled_dates' in value) || value['scheduled_dates'] === undefined) return false;
    return true;
}

export function IPayrollCalendarUpdateDtoFromJSON(json: any): IPayrollCalendarUpdateDto {
    return IPayrollCalendarUpdateDtoFromJSONTyped(json, false);
}

export function IPayrollCalendarUpdateDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPayrollCalendarUpdateDto {
    if (json == null) {
        return json;
    }
    return {
        
        'calendar_name': json['calendar_name'],
        'frequency_type': json['frequency_type'],
        'group_type': json['group_type'],
        'calculate_schedule_request_dto': ICalculateScheduleRequestDtoFromJSON(json['calculate_schedule_request_dto']),
        'scheduled_dates': new Set(json['scheduled_dates']),
        'plan_ids': json['plan_ids'] == null ? undefined : new Set(json['plan_ids']),
        'all_plan_ids': json['all_plan_ids'] == null ? undefined : json['all_plan_ids'],
        'payroll_group_ids': json['payroll_group_ids'] == null ? undefined : new Set(json['payroll_group_ids']),
    };
}

export function IPayrollCalendarUpdateDtoToJSON(json: any): IPayrollCalendarUpdateDto {
    return IPayrollCalendarUpdateDtoToJSONTyped(json, false);
}

export function IPayrollCalendarUpdateDtoToJSONTyped(value?: IPayrollCalendarUpdateDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'calendar_name': value['calendar_name'],
        'frequency_type': value['frequency_type'],
        'group_type': value['group_type'],
        'calculate_schedule_request_dto': ICalculateScheduleRequestDtoToJSON(value['calculate_schedule_request_dto']),
        'scheduled_dates': Array.from(value['scheduled_dates'] as Set<any>),
        'plan_ids': value['plan_ids'] == null ? undefined : Array.from(value['plan_ids'] as Set<any>),
        'all_plan_ids': value['all_plan_ids'],
        'payroll_group_ids': value['payroll_group_ids'] == null ? undefined : Array.from(value['payroll_group_ids'] as Set<any>),
    };
}

